import { useIntl } from 'react-intl';

type SanitizedQuestionStemProps = {
    html: string;
}

export const SanitizedQuestionStem = (props: SanitizedQuestionStemProps) => {

    const { html = '' } = props;

    const { formatMessage } = useIntl();

    const tokens = {
        audio: `[${formatMessage({ id: 'audio.121547d3', defaultMessage: 'Audio', description: 'Question stem preview token' })}]`,
        codeBlock: `[${formatMessage({ id: 'code_snippet.4c21707a', defaultMessage: 'Code Snippet', description: 'Question stem preview token' })}]`,
        codeInline: `[${formatMessage({ id: 'inline_code.408edaf6', defaultMessage: 'Inline Code', description: 'Question stem preview token' })}]`,
        diagram: `[${formatMessage({ id: 'diagram.f21d30aa', defaultMessage: 'Diagram', description: 'Question stem preview token' })}]`,
        embed: `[${formatMessage({ id: 'embed.0f07b789', defaultMessage: 'Embed', description: 'Question stem preview token' })}]`,
        image: `[${formatMessage({ id: 'image.4706f606', defaultMessage: 'Image', description: 'Question stem preview token' })}]`,
        list: `[${formatMessage({ id: 'list.d08426af', defaultMessage: 'List' })}]`,
        table: `[${formatMessage({ id: 'table.8286e068', defaultMessage: 'Table', description: 'Question stem preview token' })}]`,
        video: `[${formatMessage({ id: 'video.1c0f6381', defaultMessage: 'Video', description: 'Question stem preview token' })}]`
    };

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // 1) Drop non-content containers early
    doc.querySelectorAll('script, style, noscript, template').forEach(n => n.remove());

    // 2) Token replacements (whole-node replacements)
    [
        ['img', tokens.image],
        ['pre', tokens.codeBlock],
        ['audio', tokens.audio],
        ['video', tokens.video],
        ['iframe', tokens.embed],
        ['table', tokens.table],
        ['svg', tokens.diagram],
        ['canvas', tokens.diagram],
        ['ul', tokens.list],
        ['ol', tokens.list]
    ].forEach(([sel, token]) => {

        doc.querySelectorAll(sel).forEach(n => n.replaceWith(doc.createTextNode(' ' + token.toLowerCase() + ' ')));

    });

    // 3) Inline code after <pre> handling (treat remaining <code> inline)
    doc.querySelectorAll('code').forEach(n => n.replaceWith(doc.createTextNode(' ' + tokens.codeInline + ' ')));

    // 4) Convert <br> to space so lines don't smash
    doc.querySelectorAll('br').forEach(n => n.replaceWith(doc.createTextNode(' ')));

    // 5) Serialize text while ignoring tags (but keeping link TEXT)
    function serialize(node: any) {

        let out = '';
        node.childNodes.forEach((ch: any) => {

            if (ch.nodeType === Node.TEXT_NODE) {

                out += ch.nodeValue || '';

            } else if (ch.nodeType === Node.ELEMENT_NODE) {

                // Keep children text of anchors/spans/etc.; we already tokenized special cases above.
                out += serialize(ch);

            }

        });
        return out;

    }

    // 6) Normalize whitespace & entities
    const raw = serialize(doc.body)
        .replace(/\u00A0/g, ' ') // nbsp → space
        .replace(/\s+/g, ' ') // collapse runs
        .trim();

    return (
        <div className='d-print-none question-stem-truncate'>
            {raw}
        </div>
    );

};